export const VEHICLE_TYPES = [
  'Flatbed',
  'Step Deck',
  'Double Drop',
  'Extendable Trailers', 
  'RGN LowBed',
  'Mini Deck',
  'Jeep & Steering Dolly',
  'Single Schnabel',
  'Double Schnabel',
  'Hydraulic Platform'
];

// For select inputs that need a placeholder
export const VEHICLE_TYPES_WITH_PLACEHOLDER = [
  'Please Select Type...',
  ...VEHICLE_TYPES
];